module.exports = __webpack_public_path__ + "img/logo_join.5dc022b7.svg";